module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-fluid",
    attrs: {
      "id": "presion"
    }
  }, [_c('div', {
    staticStyle: {
      "width": ""
    },
    attrs: {
      "id": "main",
      "600px;height:400px;": ""
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-13815d32","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/test.vue
// module id = 1684
// module chunks = 6